import { render, staticRenderFns } from "./InvoicesTab.vue?vue&type=template&id=ffa1cfc0&scoped=true&"
import script from "./InvoicesTab.vue?vue&type=script&lang=js&"
export * from "./InvoicesTab.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesTab.vue?vue&type=style&index=0&id=ffa1cfc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa1cfc0",
  null
  
)

export default component.exports